<template>
    <div>
        <v-card>
            <v-card-title class="font-weight-black black--text">
                {{$t("languagePreferences")}}
            </v-card-title>
            <v-card-subtitle class="black--text">
                {{ $t('chooseYourPreferredLanguage') }}
            </v-card-subtitle>
            <v-card-text width="100%">
                <v-row>	
                    <v-col cols="6">
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                    >
                                        <label class="subtitle-1 font-weight-medium black--text" for="Select Language">{{ $t('selectLanguage') }}</label>
                                        <v-select
                                            :items="['English']"
                                            outlined
                                            dense
                                            v-model="lang"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                        
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pt-10 text-center" cols="6"></v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn disabled @click="updatePassword" right height="44" width="116" depressed color="primary">
                        {{ $t('update') }}
                    </v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";

export default {
    created() {
		
	},
    data: () => ({
        lang: 'English',
        user: {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
        },
    }),
    methods: {
        updatePassword() {
            // console.log(this.user);
        }
    },
    mixins: [loading]
}
</script>
